export default class {
  static check() {
    return Promise.resolve('authorized');
  }
}
